import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import {Scrollbars} from 'react-custom-scrollbars';
//components and assets
import Logo from '../../logo.png';
import CollapsedLogo from '../../logo_collapsed.png';
import MobileLogo from '../../logo_mobile.png';
import Menu from '../Menu';
import UserBox from '../UserBox';
import Section from '../Section';
import AdminMenu from '../AdminMenu';
//config, helpers and other
import Config from '../../config';
import {show, hide} from '../../actions/sidebar';

class Sidebar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userType: ''
        };
    }

    componentDidMount() {
        if (localStorage.getItem('apitoken')) {
            let token = localStorage.getItem('apitoken');
            let userInfo = jwtDecode(token);

            axios.get(Config.api.getDomain() + 'crud/station/' + userInfo.StationId, Config.api.getConfig()).then(response => {
                this.setState({
                    userType: response.data.stationType
                });
            }).catch(error => {
                console.log(error);
            });
        }
    }

    showSidebar = () => {
        const {dispatch} = this.props;
        dispatch(show());
    };

    hideSidebar = () => {
        const {dispatch} = this.props;
        dispatch(hide());
    };

    showHideMobileMenu(event){
        event.preventDefault();
        if (this.props.isOpen){
            const {dispatch} = this.props;
            dispatch(hide());
        } else {
            const {dispatch} = this.props;
            dispatch(show());
        }
    }

    render() {
        let classes = ['sidebar'];

        if (this.props.isOpen) {
            classes.push('sidebar--open');
        } else {
            classes.push('sidebar--collapsed');
        }

        return (
            <div>
                <div id="sidebar" className={classes.join(' ')}>
                    <div className={"sidebarWrapper"}>
                      <div className={"sidebarContent"}>
                            {this.props.isOpen &&
                            <div id="sidebarTop">
                                <button className="open" onClick={this.hideSidebar}> ‹</button>
                                <img src={Logo} width="180px" alt={"Europcar logo"} />
                            </div>
                            }
                            {!this.props.isOpen &&
                            <div id="sidebarTop">
                                <button className="open" onClick={this.showSidebar}> ›</button>
                                <img src={CollapsedLogo} width="30px" alt=''/>
                            </div>
                            }
                            <Scrollbars
                                  autoHide={false}
                                  autoHeight={true}
                                  autoHeightMin={0}
                                  autoHeightMax={"70vh"}
                                  renderThumbHorizontal={this.renderThumb}
                                  renderThumbVertical={this.renderThumb}>

                                <div className="scrollBarContent">
                                    <Menu location={this.props.location} userType={this.state.userType}/>
                                    <div className="separator"><span>&nbsp;</span></div>
                                    <UserBox/>
                                    <Section/>
                                    <AdminMenu location={this.props.location} userType={this.state.userType}/>
                                </div>

                            </Scrollbars>



                        </div>
                  </div>
                </div>
                <div className={"mobile-version "+classes.join(' ')}>
                    <Menu location={this.props.location} userType={this.state.userType}/>
                    <ul>
                        <li className="menu">
                            <a onClick={(event)=>this.showHideMobileMenu(event)} href="/#/">&nsbp;</a>
                        </li>
                        <li className="logo">
                            <a href="/#/" className={"logoMobile"}>
                                <img  src={MobileLogo} alt={"Europcar logo mobile"}/>
                            </a>
                            <a href="/#/" className={"logoCollapsed"} >
                                <img src={CollapsedLogo} alt={"Europcar logo extra small version"} />
                            </a>

                        </li>
                    </ul>
                </div>
            </div>
        );
    };
}

/**
 * Map actions to properties
 */
const mapStateToProps = (state) => ({
    isOpen: state.sidebar.isOpen
});

export default connect(mapStateToProps)(Sidebar)


// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js